__turbopack_context__.v({
  "spinner": "Search-module-scss-module__8wiNfG__spinner",
  "wrapper": "Search-module-scss-module__8wiNfG__wrapper",
});
